import React from "react";
import {
  Typography,
  CircularProgress,
  TableCell,
  TableRow,
} from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";

interface Props {
  text: string;
  spinnerSize?: number;
  spinnerSx?: SxProps<Theme>;
  textSx?: SxProps<Theme>;
  noResults?: boolean;
  table?: boolean;
}
export default function LoadingIndicator({
  text,
  spinnerSize,
  spinnerSx,
  textSx,
  noResults,
  table,
}: Props) {
  const loadingIndicator = noResults ? (
    <Typography variant="body2" component="div" color="primary" sx={textSx}>
      No Results
    </Typography>
  ) : (
    <>
      <Typography
        variant="body2"
        component="div"
        color="primary"
        sx={spinnerSx}
      >
        <CircularProgress disableShrink size={spinnerSize ? spinnerSize : 20} />
      </Typography>
      <Typography variant="body2" component="div" color="primary" sx={textSx}>
        {text}
      </Typography>
    </>
  );
  return table ? (
    <TableRow>
      <TableCell
        colSpan={100}
        // style={{ position: "absolute", width: "100%", backgroundColor: "#fff" }}
      >
        {loadingIndicator}
      </TableCell>
    </TableRow>
  ) : (
    loadingIndicator
  );
}
